import React, { useState, useEffect, useRef } from "react";
import "./App.css";

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const chatWindowRef = useRef(null);

  // Initial bot message
  useEffect(() => {
    const initialMessage =
      "Hiya! 🌟 I'm NitikaNexus 🤖, your go-to AI for all things Nitika! Whether you're curious about her work, her favorite Netflix shows, or just want to know what she's up to when she's not coding away—ask away! Let's get started! 🚀";
    setMessages([{ bot: initialMessage }]);
  }, []);

  const formatText = (text) => {
    const formattedText = text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
    return formattedText.replace(/\n/g, "<br />");
  };

  const sendMessage = async () => {
    if (input.trim() === "") return;

    try {
      const response = await fetch("https://nitikanexus.onrender.com/ask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ question: input }),
      });

      const data = await response.json();
      const formattedBotResponse = formatText(data.answer || "");
      setMessages((prev) => [...prev, { user: input, bot: formattedBotResponse }]);
      setInput("");
    } catch (err) {
      const errorMsg =
        "Oops! Something went wrong talking to the server. Please try again in a moment.";
      setMessages((prev) => [...prev, { user: input, bot: errorMsg }]);
      setInput("");
    }
  };

  // Auto-scroll chat window
  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="App">
      <h1>
        NitikaNexus <span style={{ WebkitTextFillColor: "initial" }}>🤖</span>
      </h1>

      <div className="chat-window" ref={chatWindowRef}>
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`message-container ${
              msg.user ? "user-message-container" : "bot-message-container"
            }`}
          >
            {msg.user && (
              <p className="user-message">
                <strong>You:</strong> {msg.user}
              </p>
            )}
            {msg.bot && (
              <p
                className="bot-message"
                dangerouslySetInnerHTML={{
                  __html: `<strong>NitikaNexus:</strong> ${msg.bot}`,
                }}
              />
            )}
          </div>
        ))}
      </div>

      <div className="input-container">
        <input
          type="text"
          value={input}
          placeholder="Ask NitikaNexus anything..."
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage}>
          <div className="svg-wrapper-1">
            <div className="svg-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path
                  fill="currentColor"
                  d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                ></path>
              </svg>
            </div>
          </div>
          <span>Send</span>
        </button>
      </div>
    </div>
  );
}

export default App;
